import { Grid } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { SubmitButton } from '@tassat/button';
import { Transaction } from '@tassat/payments-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface ApproveFailedTransactionProps extends WithStyles<typeof muiStyles> {
    selectedTransaction: Transaction;
    approveFailedTransaction: (transaction: Transaction) => void;
    cancelApprove: () => void;
}

const muiStyles = (theme: ApplicationMuiTheme) => ({
    promptText: {
        fontSize: '1.5rem',
        padding: '1rem 0'
    },
    radioGroup: {
        width: '100%',
        marginBottom: '2rem'
    },
    radioContainer: { margin: '0 auto' },
    radioColumn: { width: 'auto' as const },
    radio: {
        color: theme?.app?.applicationColors.enumColors.greyLight ||
            '#a7a7a7',
        '&.Mui-checked': {
            color: theme?.app?.applicationColors.failureDark ||
                '#AD3D4B'
        }
    },
    checked: {},
    cancelButton: {
        cursor: 'pointer' as const,
        fontSize: '1.2rem',
        lineHeight: '1.2rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        padding: '.3rem',
        marginTop: '1rem',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHover ||
                '#bec4cf'
        }
    }
});

function ApproveFailedTransactionComponent(props: ApproveFailedTransactionProps) {
    const {
        classes,
        selectedTransaction,
        approveFailedTransaction,
        cancelApprove
    } = props;

    return (
        <Grid
            alignItems='center'
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <span className={classes.promptText}>Are you sure you want to approve this failed transaction?</span>
            <SubmitButton
                onClick={() => {
                    approveFailedTransaction(selectedTransaction);
                }}
                type='submit'
            />
            <span
                className={classes.cancelButton}
                onClick={cancelApprove}
            >CANCEL
            </span>
        </Grid>
    );
}

const ApproveFailedTransaction = withStyles(muiStyles)(ApproveFailedTransactionComponent);
export { ApproveFailedTransaction };